import AccessibilityIcon from "@mui/icons-material/Accessibility";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import HistoryIcon from "@mui/icons-material/History";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import PsychologyIcon from "@mui/icons-material/Psychology";
import { useMemo } from "react";
import { ROUTES, USER_PROFILE } from "../constants.js";

const resolveRoute = (route, runId) => route.replace(":runId", runId);

const homePage = ({ locales, runId }) => ({
  home: {
    icon: "/assets/aleph-logo.png",
    isImage: true,
    name: locales["home.title"],
    route: resolveRoute(ROUTES.HOME, runId),
  },
});

const hostPages = ({ locales, runId }) => ({
  background: {
    icon: AccountCircleIcon,
    name: locales["background.title"],
    route: resolveRoute(ROUTES.HOST_BACKGROUND, runId),
  },
  stats: {
    icon: PsychologyIcon,
    name: locales["stats.title"],
    route: resolveRoute(ROUTES.HOST_STATS, runId),
  },
  events: {
    icon: CalendarMonthIcon,
    name: locales["events.title"],
    route: resolveRoute(ROUTES.HOST_EVENTS, runId),
  },
  log: {
    icon: HistoryIcon,
    name: locales["log.title"],
    route: resolveRoute(ROUTES.HOST_LOG, runId),
  },
});

const employeePages = ({ locales, runId }) => ({
  plots: {
    icon: NoteAltIcon,
    name: locales["plots.title"],
    route: resolveRoute(ROUTES.PLOTS.BASE, runId),
  },
  behaviour: {
    icon: PsychologyIcon,
    name: locales["behaviour.title"],
    route: resolveRoute(ROUTES.BEHAVIOUR.BASE, runId),
  },
  maintenance: {
    icon: BuildCircleIcon,
    name: locales["maintenance.title"],
    route: resolveRoute(ROUTES.MAINTENANCE.BASE, runId),
  },
  security: {
    icon: HistoryIcon,
    name: locales["security.title"],
    route: resolveRoute(ROUTES.SECURITY.BASE, runId),
  },
});

const adminPages = ({ locales, runId }) => ({
  runs: {
    icon: LibraryBooksIcon,
    name: locales["runs.title"],
    route: resolveRoute(ROUTES.RUNS.BASE, runId),
  },
  hosts: {
    icon: AccessibilityIcon,
    name: locales["hosts.title"],
    route: resolveRoute(ROUTES.HOSTS.BASE, runId),
  },
});

export default function useNavbarPages({ locales, profile, runId }) {
  return useMemo(() => {
    const home = homePage({ locales, runId });
    const rolePages = {
      [USER_PROFILE.HOST]: { ...home, ...hostPages({ locales, runId }) },
      [USER_PROFILE.EMPLOYEE]: { ...home, ...employeePages({ locales, runId }) },
      [USER_PROFILE.ADMIN]: { ...home, ...adminPages({ locales, runId }) },
    };

    return rolePages[profile] || home;
  }, [locales, profile, runId]);
}
